import React from "react";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import Input from "@mui/joy/Input";
import Sheet from "@mui/joy/Sheet";

const ConversationHistory = ({ conversations, loading }) => {
  return (
    <Sheet
      variant="outlined"
      className="!bg-white !border-gray-300 rounded-xl p-6 min-h-full"
    >
      <Typography className="text-center text-9xl m-10 font-bold">
        Conversation History
      </Typography>
      <div className="space-y-4 mb-4 max-h-[450px] overflow-y-auto">
        {loading ? (
          <Typography>Loading...</Typography>
        ) : (
          conversations.map((conv) => (
            <React.Fragment key={conv.id}>
              <div className="flex justify-end">
                <div className="max-w-[80%] p-3 rounded-lg bg-blue-50 text-blue-900">
                  <div className="flex items-center gap-2 mb-1">
                    <Typography level="body-xs" className="text-gray-600">
                      Client
                    </Typography>
                    <Typography level="body-xs" className="text-gray-500">
                      {new Date(conv.timestamp).toLocaleString()}
                    </Typography>
                  </div>
                  <Typography level="body-sm" className="text-left">
                    {conv.input}
                  </Typography>
                </div>
              </div>
              <div className="flex justify-start">
                <div className="max-w-[80%] p-3 rounded-lg bg-gray-100">
                  <div className="flex items-center gap-2 mb-1">
                    <Typography level="body-xs" className="text-gray-600">
                      Ailaa AI
                    </Typography>
                    <Typography level="body-xs" className="text-gray-500">
                      {new Date(conv.timestamp).toLocaleString()}
                    </Typography>
                  </div>
                  <Typography level="body-sm" className="text-left">
                    {conv.output}
                  </Typography>
                </div>
              </div>
            </React.Fragment>
          ))
        )}
      </div>
      <div className="flex gap-2 align-baseline ">
        <Input placeholder="Type your message..." className="flex-1" />
        <Button color="primary" disabled>
          Send
        </Button>
      </div>
    </Sheet>
  );
};

export default ConversationHistory;
